export default __webpack_public_path__ + "static/media/hotwatertimer1.92a95f4d.png";